import React, { useState, useEffect, memo } from 'react';
import { View } from 'react-native';
import { Indicator, ToolTip } from 'design-system';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { useCurrentPrice } from '../hooks/selectors';
import { formatAmount, formatNumberOfShares } from '../utils';
import { commonToolTipStrings } from '../constants';
import { isWeb } from '../../../constants';
import { selectIsTradingAccountAlpaca } from '../reducers/selectors';
const strings = {
    numberOfShares: 'No. of shares (est.)',
    latestPrice: 'Latest price: ',
    lastClosedPrice: 'Last close price: ',
};
const NumberOfSharesPreview = (props) => {
    const { assetId, latestPrice, quantity, loading } = props;
    const currentPrice = useCurrentPrice(assetId);
    const isAlpacaAccount = useAppSelector(selectIsTradingAccountAlpaca);
    const [price, setPrice] = useState(() => {
        if (latestPrice)
            return latestPrice;
        return currentPrice || null;
    });
    const colors = useColors();
    const styles = useStyles(styleSet);
    // latestPrice taking precedence over currentPrice
    useEffect(() => {
        if (latestPrice) {
            setPrice(latestPrice);
        }
    }, [latestPrice]);
    if (price === null) {
        return null;
    }
    return (<View style={styles.container}>
      <View>
        <View style={styles.row}>
          <Text Text-14>{strings.numberOfShares}</Text>
          <Spacer w={4}/>
          <ToolTip small offset={1} colorKey="secondary" title={commonToolTipStrings.noOfSharesTitle} subtitle={props.hasFXFee ? commonToolTipStrings.noOfSharesDesc : commonToolTipStrings.noOfSharesWithoutFxFeeDesc}/>
        </View>
        <Text NumbersThin-14 Secondary>
          <Text TextThin-14 Secondary>
            {isAlpacaAccount ? strings.latestPrice : strings.lastClosedPrice}
          </Text>
          {formatAmount(price)}
        </Text>
      </View>
      <Spacer w={8}/>
      {loading ? (<Indicator style={styles.loadingIndicator} color={colors.text.secondary}/>) : (<Text Numbers-16 flex right numberOfLines={1}>
          {formatNumberOfShares(quantity ?? 0, false)}
        </Text>)}
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        // Its parent centres its children; on web that would shrink the card to its text
        ...(isWeb && { alignSelf: 'stretch' }),
        flexDirection: 'row',
        alignItems: 'center',
        height: rem(60),
        paddingHorizontal: rem(16),
        marginHorizontal: rem(16),
        borderRadius: rem(9),
        backgroundColor: colors.cards.onLight,
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    loadingIndicator: {
        flex: 1,
        backgroundColor: 'transparent',
        alignItems: 'flex-end',
    },
}));
export default memo(NumberOfSharesPreview);
